import {Divider, Typography, TypographyProps} from '@mui/material';
import React from 'react';

type A360CommissionSectionProps = {
  title?: string;
  align?: TypographyProps['align'];
  fontSize?: string | number;
  className: string;
  children: React.ReactNode;
  withSeparator?: boolean;
  'aria-label': string;
};

export const A360CommissionSection = (props: A360CommissionSectionProps) => {
  const {align, children, className, fontSize, title, withSeparator} = props;
  return (
    <section className={className} aria-label={props['aria-label']}>
      {title && (
        <Typography
          variant="h2"
          component="h2"
          className="a360-commissions__section-title"
          style={{
            textAlign: align,
            fontSize: fontSize ?? '1.25rem',
            fontWeight: 700,
          }}
        >
          {title}
        </Typography>
      )}
      {withSeparator && <Divider style={{width: '100%'}} />}
      {children}
    </section>
  );
};
